import type { ReactNode } from 'react';

type UseCaseBandProps = {
  tone: 'light' | 'dark';
  id?: string;
  className?: string;
  containerClassName?: string;
  children: ReactNode;
};

export function UseCaseBand({
  tone,
  id,
  className,
  containerClassName,
  children,
}: UseCaseBandProps) {
  const sectionClass = ['band-' + tone, className].filter(Boolean).join(' ');
  const containerClass = ['container', containerClassName].filter(Boolean).join(' ');

  return (
    <section className={sectionClass} id={id}>
      <div className={containerClass}>{children}</div>
    </section>
  );
}
